import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { mapGetters } from 'vuex';
import * as accountTypes from '@account/store/types'
import { getProfilePhotoUrl } from '@appbase/util'

@Component({
    computed: mapGetters({
        user: accountTypes.CURRENT
    })
})
export default class MyInfoWebpart extends Vue {
    user!: account.TCurrent;

    getPhotoUrl(){
        return getProfilePhotoUrl(this.user.user.photoPath, this.user.user.personCode)
    }
}
